<template>
  <div class="">
    <h2 class="tituloHead">
      {{ current_championship.name }}
      <span v-if="current_course" class="label label-info">{{ current_course.name }}</span>
      <span class="label" :class="[current_date.finished == 1 ? 'label-default' : 'label-success']" v-if="current_date">
        {{ current_date.date | moment }}
      </span>
    </h2>
    <menu-home v-if="current_championship">
      <div slot="title">Seleccione</div>
      <div slot="buttons" aria-label="Justified button group" role="group" class="btn-group btn-group-justified">
        <menu-button menu-url="/championship/game" glyph-icon="glyphicon-refresh">Juego</menu-button>
        <menu-button menu-url="/championship/players" glyph-icon="glyphicon-user">Jugadores</menu-button>
        <menu-button menu-url="/championship/fixtures" glyph-icon="glyphicon-arrow-up">Salidas</menu-button>
        <menu-button menu-url="/championship/results" glyph-icon="glyphicon-stats">Resultados</menu-button>
      </div>
    </menu-home>

    <router-view></router-view>
  </div>
</template>

<script>
import MenuHome from '../components/MenuHome'
import MenuButton from '../components/MenuButton'
import configure from '../configure'

import * as actions from '../vuex/actions'
import {
  getCurrentChampionship,
  getCurrentDate,
  getCurrentCourse,
  getLoading
} from '../vuex/getters'

export default{
  components: { MenuHome, MenuButton },
  vuex: {
    getters: {
      current_date: getCurrentDate,
      current_course: getCurrentCourse,
      show_spinner: getLoading,
      current_championship: getCurrentChampionship
    },
    actions: actions
  }
}
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Championship.vue?c6e665ce
 **/